import { TextField } from '@rematter/ui-web';

import { useTranslations } from '@/facilities/i18n/useTranslations';

interface Address {
  streetAddress: string;
  city: string;
  state: string;
  country: string;
  postalCode: string;
}

interface FormData {
  address: Address;
}

interface AddressSectionProps {
  form: FormData;
  onFieldChange: <K extends keyof FormData>(
    field: K,
  ) => (value: FormData[K]) => void;
}

export const AddressSection = ({
  form,
  onFieldChange,
}: AddressSectionProps) => {
  const t = useTranslations();

  const handleAddressFieldChange =
    (field: keyof Address) => (value: string) => {
      onFieldChange('address')({
        ...form.address,
        [field]: value,
      });
    };

  return (
    <div className="@AddressSection space-y-4">
      <TextField
        label={t.facilities.form.fields.address.streetAddress.label}
        placeholder={t.facilities.form.fields.address.streetAddress.placeholder}
        value={form.address.streetAddress}
        onChange={handleAddressFieldChange('streetAddress')}
        isRequired
      />

      <div className="grid grid-cols-2 gap-4">
        <TextField
          label={t.facilities.form.fields.address.city.label}
          placeholder={t.facilities.form.fields.address.city.placeholder}
          value={form.address.city}
          onChange={handleAddressFieldChange('city')}
          isRequired
        />

        <TextField
          label={t.facilities.form.fields.address.state.label}
          placeholder={t.facilities.form.fields.address.state.placeholder}
          value={form.address.state}
          onChange={handleAddressFieldChange('state')}
          isRequired
        />
      </div>

      <div className="grid grid-cols-2 gap-4">
        <TextField
          label={t.facilities.form.fields.address.country.label}
          placeholder={t.facilities.form.fields.address.country.placeholder}
          value={form.address.country}
          onChange={handleAddressFieldChange('country')}
          isRequired
        />

        <TextField
          label={t.facilities.form.fields.address.postalCode.label}
          placeholder={t.facilities.form.fields.address.postalCode.placeholder}
          value={form.address.postalCode}
          onChange={handleAddressFieldChange('postalCode')}
          isRequired
        />
      </div>
    </div>
  );
};
